import '../styles/UserProfileModal.css';

import React, { useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import DefaultProfileImage from '../assets/profile-image-default.png';
import { FaUpload } from 'react-icons/fa';
import { FiCamera } from 'react-icons/fi';
import { IoMdClose } from 'react-icons/io';
import Loader from '../components/atoms/Loader.jsx';
import { updateProfileURL } from '../store/userDetailsSlice.js';
import { uploadProfilePicture } from '../services/UsersApi.js';

const UploadProfileModal = ({ onClose }) => {
	const [selectedImage, setSelectedImage] = useState(DefaultProfileImage);
	const [file, setFile] = useState(null);
	const fileInputRef = useRef(null);
	const { userId } = useSelector((state) => state.userDetails);
	const [isLoading, setIsLoading] = useState(false);

	const dispatch = useDispatch();

	const handleImageChange = (e) => {
		const file = e.target.files[0];
		if (file) {
			setFile(file);
			setSelectedImage(URL.createObjectURL(file));
		}
	};

	const handleRemoveImage = () => {
		setSelectedImage(null);
	};

	const handleUpload = async (e) => {
		try {
			setIsLoading(true);
			const file = e.target.files[0];
			if (file) {
				setFile(file);
				//setSelectedImage(URL.createObjectURL(file));
			}
			if (!file) {
				fileInputRef.current.click();
				return;
			}
			const formData = new FormData();
			formData.append('profileImage', file);
			formData.append('userId', userId); // Replace with actual user ID
			let result = await uploadProfilePicture(formData);
			result = result.data;
			console.log('Upload result:', result);
			if (result.imageUrl) {
				dispatch(updateProfileURL(result.imageUrl));
				setSelectedImage(result.imageUrl || DefaultProfileImage);
			}
		} catch (error) {
			console.log('Failed to upload image:', error);
		} finally {
			setIsLoading(false);
		}
	};

	return (
		<div className="user-profile-modal-overlay">
			<div className="user-profile-modal-content">
				<button className="user-profile-close-button" onClick={onClose}>
					<IoMdClose size={24} />
				</button>
				{isLoading ? (
					<div className="user-profile-modal-loader-wrapper">
						<Loader />
					</div>
				) : (
					<>
						<h2>Upload Profile Picture</h2>
						<div className="profile-preview-section">
							<img
								src={selectedImage}
								alt="Profile Preview"
								className="profile-preview"
							/>
							{selectedImage && (
								<p className="remove-pic" onClick={handleRemoveImage}>
									Remove Profile Pic
								</p>
							)}
						</div>
						<div className="user-profile-modal-actions">
							<label className="camera-label">
								<FiCamera size={22} />
								<span>Take a Picture</span>
								<input
									type="file"
									accept="image/*"
									style={{ display: 'none' }}
									onChange={handleImageChange}
								/>
							</label>

							<button
								className="user-profile-upload-button"
								onClick={() => fileInputRef.current.click()}
							>
								<input
									type="file"
									accept="image/*"
									ref={fileInputRef}
									style={{ display: 'none' }}
									onChange={handleUpload}
								/>
								Upload
							</button>
						</div>
					</>
				)}
			</div>
		</div>
	);
};

export default UploadProfileModal;
